import { LocalDateTime } from "@flockcover/flock-svc-core-types"
import { Box, CellProps, Text } from "@shared/primitive-components"
import { localDateTimeToString } from "@shared/utils/formatters/dates"
import { rebatesStyles as styles } from "../../../styles"

type Props = {
  dataTestIds?: {
    DAY_DATE: string
    TIME: string
  }
}
export const TripCompletedCell = <T extends Record<string, unknown>>({ dataTestIds }: Props) =>
  function ({ value }: CellProps<LocalDateTime, T>) {
    return (
      <Box css={styles.marginY(2)}>
        <Text data-testid={dataTestIds?.DAY_DATE}>{localDateTimeToString(value, `en`, `dd/MM/yyy`)}</Text>
        <Text data-testid={dataTestIds?.TIME} use="body2">
          {localDateTimeToString(value, `en`, `h:mmaaa`)}
        </Text>
      </Box>
    )
  }
